import http from './http'



export const login = (data)=>{
  return http.post('/login',data)
}

export const siderbarsIndex = ()=>{
  return http.get('/siderbarsIndex')
}


export const siderbars = (data)=>{
  return http.post('/siderbars',data)
}



// WEBPACK FOOTER //
// ./src/api/api.js